import {
    Component,
    EventEmitter,
    Input,
    Output,
    ElementRef,
    OnInit,
    OnChanges,
    SimpleChanges,
    OnDestroy
} from '@angular/core';
import * as _ from 'lodash';
import { StringUtils} from '../../../shared/utils/src/string.utils';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs/Subscription';

interface IOption {
    id?: string;
    name: string;
    icon: string;
}

@Component({
    selector: 'sui-select-component',
    templateUrl: './sui-select.component.html',
    styleUrls : [
        './element.select.scss',
        './component.custom-select.scss'
    ]
})
export class SuiSelectComponent implements OnInit, OnChanges, OnDestroy {
    @Input() isMulti: Boolean = false;
    @Input() searchable: Boolean = true;
    @Input() disabled: Boolean = false;
    @Input() hideLabels: Boolean = false;
    @Input() selectedValue: string;
    @Input() selectedValues: Array<any>;
    @Input() isInvalid: boolean;
    @Input()
    public set selectConfig(conf: any) {
        this._selectConfig = conf;
        this._selectConfig.options = this.getOptions(conf);
    }
    @Output() public selectChanged: EventEmitter<any> = new EventEmitter();

    public get selectConfig() {
        return this._selectConfig;
    }
    placeholder: string;
    selectedYN = false;     ///권한에 따르 selectconfig의 option리스트에 해당 항목이 없는경우가 발생할경우 validation에 문제가 생김. 이를 해결하기 위하여 selectedYN란 변수를 생성하고 셀렉트박스를 변경할때 true로 바꾼후 validation에서 false인경우 invalid로 처리

    private _selectConfig: any = {};

    // public options: IOption[];
    public selectedOption: IOption;
    public selectedOptions: IOption[];

    private subscription: Subscription;

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
        if (this.selectedValue && this.selectedValue !== '-') {
            this.getSelectedOption();
        }
        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this._selectConfig.options = this.getOptions(this._selectConfig);
            this.getSelectedOption();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        const chng = changes['selectedValue'];
        if (chng && !chng.firstChange) {
            if (this.selectedValue !== '-') {
                this.getSelectedOption();
            }
        }
        const configChng = changes['selectConfig'];
        if (configChng && configChng.currentValue !== undefined && (configChng.currentValue !== configChng.previousValue)) {
            this.getSelectedOption();
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    getOptions(conf): Array<any> {
        const _options = [];
        if (conf.defaultOption.useFlag) {
            _options.push({
                id: conf.defaultOption.value,
                name: this.translate.instant(conf.defaultOption.label)
            });
        }
        conf.option.forEach(({value, label, icon}) => {
            if (value && label) {
                _options.push({
                    id: value,
                    name: label,
                    icon: icon ? icon : ''
                });
            }
        });
        return _options;
    }

    getSelectedOption() {
        try {
            this.selectedYN = false;
            this._selectConfig.options.forEach((option: any) => {
                if (String(option.id) === String(this.selectedValue)) {
                    this.selectedOption = option;
                    this.selectedYN = true;
                    return;
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    ItemChange(event, eventI) {
      const Wrapper = event.target.closest('.dropdown');
      const MenuVisible = Wrapper.querySelectorAll('.menu')[0];

      if(eventI){
        Wrapper.style.alignContent = '';
        Wrapper.style.height = 'auto';
      } else {
        setTimeout(() => {
          Wrapper.style.alignContent = 'flex-start';
          Wrapper.style.height = '32px';
        }, 300);
      }
    }

    modelChanged() {
        if (this.selectedOption.id === '') {
            this.selectedOption = {
                id: '',
                name: this.translate.instant(this._selectConfig.defaultOption.label),
                icon: ''
            };
        }
        if (this.selectedOption.name) {
            this.selectedValue = this.selectedOption.id;
            this.selectedYN = true;
        }
        this.selectChanged.emit(this.selectedOption);
    }

    public setInvalid() {
        this.isInvalid = false;
    }

    public validation() {
        this.isInvalid = false;
        if (StringUtils.isEmpty(String(this.selectedValue)) || !this.selectedYN ) {
            this.isInvalid = true;
        }
        return !this.isInvalid;
    }

    public getSelectedLabel() {
        return _.find(this._selectConfig.option, {'id': this.selectedValue})['name'];
    }

    public initSelectedValue() {
        this.selectedValue = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/form/select/sui-select.component.ts